import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_safety_measures_in_place_11'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_safety_measures_in_place_11',
  name: 'Does the facility have any of the following safety measures in place related to machinery and equipment?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'MACHINERY_AND_EQUIPMENT_HAVE_A_FUNCTIONING_LOCKOUT_TAGOUT_PROGR',
      text: 'Machinery and equipment have a functioning lockout/tagout program, if applicable',
      externalIds: [
        {
          id: 'hs-32-10x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKER_MACHINERY_AND_EQUIPMENT_TRAINING_RECORDS_ARE_MAINTAINED_',
      text: 'Worker machinery and equipment training records are maintained for at least the last 12 months',
      externalIds: [
        {
          id: 'hs-32-13x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MACHINERY_AND_EQUIPMENT_HAVE_SAFETY_INSTRUCTIONS_DISPLAYED_OR_P',
      text: "Machinery and equipment have safety instructions displayed or posted in the facility in workers' language(s)",
      externalIds: [
        {
          id: 'hs-32-14x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-32-15x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'MACHINERY_AND_EQUIPMENT_HAVE_A_FUNCTIONING_LOCKOUT_TAGOUT_PROGR',
                'WORKER_MACHINERY_AND_EQUIPMENT_TRAINING_RECORDS_ARE_MAINTAINED_',
                'MACHINERY_AND_EQUIPMENT_HAVE_SAFETY_INSTRUCTIONS_DISPLAYED_OR_P',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-wor-2',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 15870,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
